import { Button, ButtonGroup, ModalBody, ModalFooter } from "@chakra-ui/react";
import { SubmitHandler } from "react-hook-form";

import PrimaryButton from "components/PrimaryButton";
import SubmitButton from "components/SubmitButton";
import { RequestModal, RequestModalProps } from "components/RequestModals";

export const ConfirmRequestedOrder = ({
  numberOfOrders,
  isOpen,
  onClose = () => {
    return;
  },
  quantityPerOrder,
  unitOfMeasure,
  customerName,
  onSubmit,
}: {
  numberOfOrders: number;
  quantityPerOrder: number;
  unitOfMeasure: string;
  customerName: string;
  onSubmit: SubmitHandler<any>;
} & RequestModalProps) => {
  return (
    <RequestModal isOpen={isOpen} onClose={onClose} header={customerName}>
      <ModalBody>
        You are requesting {numberOfOrders} order(s) of {quantityPerOrder}{" "}
        {unitOfMeasure}, would you like to proceed?
      </ModalBody>
      <ModalFooter>
        <ButtonGroup>
          <Button colorScheme="gray" onClick={onClose} variant="secondary">
            Back
          </Button>
          <SubmitButton onClick={onSubmit} type="button">
            Confirm
          </SubmitButton>
        </ButtonGroup>
      </ModalFooter>
    </RequestModal>
  );
};

export const ReleaseNumberSuccessMessage = ({
  isOpen,
  onClose = () => {
    return;
  },
  releaseNumber,
  customerName,
}: { releaseNumber: number[]; customerName: string } & RequestModalProps) => {
  return (
    <RequestModal isOpen={isOpen} onClose={onClose} header={customerName}>
      <ModalBody>
        Release{" "}
        {releaseNumber.length > 1
          ? `#'s ${releaseNumber[0]} to ${
              releaseNumber[releaseNumber.length - 1]
            } have`
          : `# ${releaseNumber} has`}{" "}
        been assigned.
      </ModalBody>
      <ModalFooter>
        <PrimaryButton mr={3} onClick={onClose}>
          Ok
        </PrimaryButton>
      </ModalFooter>
    </RequestModal>
  );
};
